import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import {
  mapImportGSTResponseToForm,
  mapGSTFormToRequest,
} from "../../../../../redux/mappers/Import/CreateNewJob/mapCustDutyResponseToForm";
export const importProductGSTApi = createApi({
  reducerPath: "importProductGST",
  baseQuery,
  tagTypes: ["importProductGST"], ///v1/import/product/gst/{importProductId}
  endpoints: (builder) => ({
    createProductGST: builder.mutation({
      query: ({ id, ...formData }) => {
        const payload = mapGSTFormToRequest(formData);

        return {
          url: `import/product/gst/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: payload, // ✅ send only this
        };
      },
      invalidatesTags: ["importProductGST"],
    }),

    updateProductGST: builder.mutation({
      query: ({ id, subId, ...formData }) => {
        const payload = mapGSTFormToRequest(formData);

        return {
          url: `import/product/gst/${id}`,
          method: "PUT",
          body: payload, // ✅ send only this

          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
        };
      },
      invalidatesTags: ["importProductGST"],
    }),

    getProductGSTId: builder.query({
      query: ({ id }) => `import/product/gst/${id}`,
      transformResponse: (response) => {
        console.log("🟧 GET GST RAW API:", response);
        console.log("🟩 Sending to mapper:", response?.data);
        return mapImportGSTResponseToForm(response?.data);
      },
      providesTags: ["importProductGST"],
    }),
  }),
});

export const {
  useCreateProductGSTMutation,
  useUpdateProductGSTMutation,
  useLazyGetProductGSTIdQuery,
} = importProductGSTApi;
